import { motion } from "framer-motion";
import { ReceiptCard } from "./ReceiptCard";

const POINTS = [
  {
    n: "01",
    title: "Search before you pay",
    body: "Type the seller, the course, the bundle. See what real buyers got at every price step — before your money leaves your account.",
  },
  {
    n: "02",
    title: "Every verified review has proof",
    body: "Payment screenshot + product screenshot, or it doesn't get the verified stamp. That's the whole rule. No proof, no verified review.",
  },
  {
    n: "03",
    title: "Facts, not name-calling",
    body: 'We record what you paid and what you got. We never label anyone a "fraud." You read the receipt and decide for yourself.',
  },
  {
    n: "04",
    title: "The room they wouldn't let you into",
    body: "Buyers compare notes here — the exact thing muted groups and admin-only channels were built to prevent.",
  },
];

export const Solution = () => (
  <section data-testid="solution-section" className="grain bg-night text-white py-24 sm:py-32 relative overflow-hidden">
    <div className="relative max-w-6xl mx-auto px-6">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.6 }}
        className="max-w-2xl"
      >
        <div className="flex items-center gap-4">
          <span className="font-display text-4xl sm:text-5xl font-bold outline-word-light leading-none select-none" aria-hidden="true">03</span>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-gold">What we're building</p>
        </div>
        <h2 className="mt-4 font-display text-4xl sm:text-5xl font-bold tracking-tight leading-tight">
          One place where the receipts do the talking.
        </h2>
        <p className="mt-4 text-base sm:text-lg text-gray-400">
          Not a wall of angry opinions. A searchable record of what people actually paid and actually received —
          verified with proof, so you can trust it.
        </p>
      </motion.div>

      <div className="mt-16 grid lg:grid-cols-2 gap-14 items-center">
        <div className="space-y-4">
          {POINTS.map((p, i) => (
            <motion.div
              key={p.n}
              data-testid={`solution-point-${i}`}
              className="flex gap-6 rounded-2xl border border-white/10 bg-white/[0.03] p-6 sm:p-7 transition-colors duration-300 hover:border-verified/40"
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.55, delay: i * 0.1 }}
            >
              <span className="font-display text-sm font-bold text-verified pt-1">{p.n}</span>
              <div>
                <h3 className="font-display text-xl font-semibold tracking-tight">{p.title}</h3>
                <p className="mt-2 text-sm text-gray-400 leading-relaxed">{p.body}</p>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          className="max-w-md w-full mx-auto lg:ml-auto"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7, delay: 0.2 }}
        >
          <ReceiptCard dark float testId="solution-receipt-card" />
          <p className="mt-5 text-center text-xs uppercase tracking-[0.2em] text-gray-500 font-semibold">
            What every listing looks like before you pay
          </p>
        </motion.div>
      </div>
    </div>
  </section>
);
